const ComponentSpinner = props => {
  const { fixed } = props

  return (
    <div className={`fallback-spinner background${fixed ? ' fixed' : ''}`}>
      <div className='loading'>
        <div className='effect-1 effects'></div>
        <div className='effect-2 effects'></div>
        <div className='effect-3 effects'></div>
      </div>
    </div>
  )
}

export default ComponentSpinner
